<template>
  <ul v-if="addons.length > 4" class="list">
    <li v-for="(item, idx) in visible" :key="idx">
      {{ `x${item.quantity} ${item.name}` }}
    </li>

    <li class="link" @click="onShowMore">
      {{ $t("button.show-more") }}
    </li>
  </ul>

  <ul v-else-if="addons.length" class="list">
    <li v-for="(item, idx) in addons" :key="idx">
      {{ `x${item.quantity} ${item.name}` }}
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";

import { useOrdersAddonsInject } from "../../composables/useOrdersAddons";
import { useOrdersDialogsInject } from "../../composables/useOrdersDialogs";

const props = defineProps<{ row: Record<string, unknown> }>();

const addonsApi = useOrdersAddonsInject();
const dialogs = useOrdersDialogsInject();

const bookingId = computed<string>(() => String(props.row.id));
const addons = computed(
  () => addonsApi.addonsByBooking.value[bookingId.value] ?? []
);
const visible = computed(() => addons.value.slice(0, 4));

onMounted(() => {
  addonsApi.requestForId(bookingId.value);
});

/**
 * Open the shared addons dialog with this row's full addon list.
 *
 * @returns {boolean} Sentinel.
 */
function onShowMore(): boolean {
  dialogs.openAddons(addons.value);

  return true;
}
</script>

<style scoped lang="scss">
@use "@/styles/variables.scss" as *;

.list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.link {
  text-decoration: underline;
  cursor: pointer;
  color: $color-dark-cyan;
}
</style>
